import { createSlice } from '@reduxjs/toolkit';
import { fetchTimeSheet, changeWorkingHours } from '../thunks/timeSheetThunks.js';

const initialState = {
    changedWorkingHours: [],
    loading: false,
    error: null,
};

const timeSheetSlice = createSlice({
    name: 'timeSheet',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTimeSheet.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchTimeSheet.fulfilled, (state, action) => {
                Object.assign(state, action.payload);
                state.loading = false;
            })
            .addCase(fetchTimeSheet.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error?.message;
            })
            .addCase(changeWorkingHours.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(changeWorkingHours.fulfilled, (state, action) => {
                state.changedWorkingHours.push(action.payload);
                state.loading = false;
            })
            .addCase(changeWorkingHours.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error?.message;
            })
            .addDefaultCase((state) => state);
    },
});

export default timeSheetSlice.reducer;
